import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import {Modal, Button} from 'antd'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'
import {IPayByLinkStore} from '@/pages/PayByLink/IPayByLinkStore'
import {PayByLinkStoreSymbol} from '@/pages/PayByLink'

export const NewPaymentLinkNotificationModal = observer(() => {
    const { t } = useTranslation()
    const store = useInjection<IPayByLinkStore>(PayByLinkStoreSymbol)

    return (
        <Modal
            title={t('NewPaymentLinkNotificationModal.title')}
            open={store.isNewPaymentLinkNotificationModalOpen}
            onCancel={() => store.closeNewPaymentLinkNotificationModal()}
            footer={
                <Button onClick={() => store.closeNewPaymentLinkNotificationModal()}>
                    {t('NewPaymentLinkNotificationModal.buttonText')}
                </Button>
            }
        >
            <Trans i18nKey='NewPaymentLinkNotificationModal.text' components={{ br: <br/> }} />
        </Modal>
    )
})
